__turbopack_context__.v({
  "switcher": "switcher-module__uc-CBG__switcher",
});
